export default function emitAsync(
    socket,
    event,
    payload = undefined,
    timeout = 60000
) {

    return new Promise((resolve, reject) => {

        if (!socket?.connected) {
            reject(new Error(`Socket desconectado: ${event}`));
            return;
        }

        const callback = (err, response) => {

            if (err) {
                reject(
                    new Error(`Timeout no evento: ${event}`)
                );
                return;
            }

            if (!response?.ok) {
                reject(response);
                return;
            }

            resolve(response);

        };

        const emitter = socket.timeout(timeout);

        if (payload === undefined) {
            emitter.emit(event, callback);
            return;
        }

        emitter.emit(event, payload, callback);

    });

}